(function() {
  'use strict';

  angular
    .module('iqxCore')
    .config($routeProviderConfig)

  function $routeProviderConfig($routeProvider){
    angular.forEach(iqxWebRoutes, function(value){
      $routeProvider.when(value.url, value.obj)
    })
    $routeProvider.otherwise({redirectTo: '/404'}) // if route not defined then re-direct them to 404 page
  }

})()
